import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import LinkWrapper from '@common/components/linkWrapper';
import Profile from '@common/components/profile';
import Api from '../../../../common/services/api';
import Modal from '../../../../common/components/modal';
import SearchableList from '../../../../common/components/list/search';
import ImageItem from '../../../../common/components/image-item';

class TeamDetailModal extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    team: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.handleRequest = this.handleRequest.bind(this);
  }

  handleRequest(offset, filter, limit = 15) {
    const { team } = this.props;

    const query = Api.utils.toQuery({
      offset,
      limit,
      q: filter.query,
    });

    return Api.get(`/v1/teams/${team.id}/users?${query}`);
  }

  render() {
    const { children, team, t } = this.props;

    return (
      <Modal
        title={<span><Trans i18nKey="network:team_title" values={{ teamName: team.name }} /></span>}
        content={(
          <SearchableList
            data={{
              onFetch: this.handleRequest,
            }}
            renderRow={(props) => (
              <LinkWrapper url={`/networks/${team.network_id}/users/${props.item.id}/about`} className="tw-text-inherit hover:tw-text-inherit tw-mb-2 last:tw-mb-0 tw-block">
                <Profile enablePopover size={30} {...props} />
              </LinkWrapper>
            )}
            rowProps={(user) => ({
              mask: true,
              image: user.profile_img,
              name: user.full_name,
              user: { id: user.id, full_name: user.full_name, profile_img: user.profile_img },
            })}
            containerClassName="ItemsList"
            placeholder={t('network:team_placeholder')}
          />
        )}
      >
        {children}
      </Modal>
    );
  }
}

export default withTranslation()(TeamDetailModal);
